<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M0.37,783.4c2.14-0.03,4.29,0.62,6.1,1.97c2.85,2.12,4.3,5.54,3.99,8.95H8.64c0.32-2.84-0.87-5.71-3.26-7.48
	c-2.97-2.2-7.03-2.15-9.93,0.13c-2.28,1.79-3.39,4.59-3.08,7.35h-1.83c-0.3-3.31,1.06-6.65,3.78-8.78
	C-3.91,784.14-1.77,783.43,0.37,783.4L0.37,783.4z M0.46,787.04c1.37-0.01,2.75,0.42,3.9,1.29c1.87,1.42,2.75,3.73,2.42,5.98H4.95
	c0.35-1.69-0.28-3.46-1.7-4.53c-1.65-1.25-3.92-1.23-5.56,0.04c-1.38,1.08-1.99,2.83-1.65,4.49h-1.83c-0.32-2.22,0.53-4.5,2.36-5.93
	C-2.28,787.5-0.91,787.05,0.46,787.04L0.46,787.04z M3.23,793.41c0,1.19-0.78,2.25-1.92,2.6v2.86l1.92,1.82v0.91h-5.46v-0.91
	l1.92-1.82v-2.85c-1.14-0.36-1.92-1.41-1.92-2.61c0-1.51,1.22-2.73,2.73-2.73C2.01,790.68,3.23,791.9,3.23,793.41z"/>
</svg>

</template>